import ItemCollector from '@components/Filters/Filters/queries/ItemCollector';

export const AIRCRAFT_OTHER_KEY = 'OTHER';

export const AircraftCollector = () => {
  const aircraftModels = new Set<string>();
  const aircraftModelCollector = ItemCollector<{
    id: string;
    checked: boolean;
  }>();
  return {
    add: (_: number, aircraft?: string | null) => {
      if (!aircraft && !aircraftModels.has(AIRCRAFT_OTHER_KEY)) {
        aircraftModels.add(AIRCRAFT_OTHER_KEY);
        aircraftModelCollector.add({ id: AIRCRAFT_OTHER_KEY, checked: true });
      } else if (aircraft) {
        aircraftModels.add(aircraft);
        aircraftModelCollector.add({ id: aircraft, checked: true });
      }
    },
    build: () => {
      const builtAircraftModels = aircraftModelCollector.build();
      return builtAircraftModels.sort(({ id: firstId }, { id: secondId }) => {
        if (firstId < secondId) return -1;
        if (firstId > secondId) return 1;
        return 0;
      });
    },
  };
};

export default AircraftCollector;
